import React, { useState, useEffect, useRef } from 'react'
import * as styles from "./SitePlan.module.scss";
import sitePlanImage1 from "../../../images/on-going-projects/srinivasa/site-plan/Site-1.jpg";
import sitePlanImage2 from "../../../images/on-going-projects/srinivasa/site-plan/Site-2.jpg";
import sitePlanImage3 from "../../../images/on-going-projects/srinivasa/site-plan/Site-3.jpg";
import sitePlanImage4 from "../../../images/on-going-projects/srinivasa/site-plan/Site-4.jpg";
import sitePlanImage5 from "../../../images/on-going-projects/srinivasa/site-plan/Site-5.jpg";
import sitePlanImage6 from "../../../images/on-going-projects/srinivasa/site-plan/Site-6.jpg";
import sitePlanImage7 from "../../../images/on-going-projects/srinivasa/site-plan/Site-7.jpg";
import sitePlanImage8 from "../../../images/on-going-projects/srinivasa/site-plan/Site-8.jpg";
import sitePlanImage9 from "../../../images/on-going-projects/srinivasa/site-plan/Site-9.jpg";
import sitePlanImage10 from "../../../images/on-going-projects/srinivasa/site-plan/Site-10.jpg";
import sitePlanImage11 from "../../../images/on-going-projects/srinivasa/site-plan/Site-11.jpg";
import bgImage from "../../../images/on-going-projects/srinivasa/header-icon.png";
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons';
import ImageModal from '../enchanted/ImageModal.jsx';


function SitePlan({currentSectionIndex}) {
const imageArray = [sitePlanImage1, sitePlanImage11, sitePlanImage10, sitePlanImage9, sitePlanImage8, sitePlanImage7, sitePlanImage6, sitePlanImage5, sitePlanImage4, sitePlanImage3, sitePlanImage2];
const imageArrayMobile = [sitePlanImage1, sitePlanImage11, sitePlanImage10, sitePlanImage9, sitePlanImage8, sitePlanImage7, sitePlanImage6, sitePlanImage5, sitePlanImage4, sitePlanImage3, sitePlanImage2];
const newImageArray = [...imageArray, ...imageArray, ...imageArray, ...imageArray];
const [activeImage, setActiveImage] = useState(2 * imageArray.length);
const [activeImageMobile, setActiveImageMobile] = useState(0);
const [endTransition, setEndTransition] = useState(false);
const timer = useRef(null);
const [pauseAutoplay, setPauseAutoplay] = useState(false);
const [showModal, setShowModal] = useState(false);
const [showSelectedImage, setShowSelectedImage] = useState(1);
const [arrayType, setArrayType] = useState(1);

  useEffect(() => {
    if(typeof window !== 'undefined' && window.innerWidth > 1024) {
    if(currentSectionIndex === 4) {
      if(pauseAutoplay || showModal) {
        clearInterval(timer.current);
        return;
      }
    timer.current = setInterval(() => {
        setEndTransition(false);
        setActiveImage((prev) => prev - 1);
    }, 2500);
    }
    }
    return () => clearInterval(timer.current);
  }, [currentSectionIndex, pauseAutoplay, showModal]);

  useEffect(() => {
      if((activeImage === imageArray.length) || (activeImage === 3 * imageArray.length)) {
        setTimeout(() => {
          setEndTransition(true);
          setActiveImage(2 * imageArray.length);
        }, 800);
      }
  }, [activeImage]);

  function prevSlide() {
    setEndTransition(false);
    setActiveImage((prev) => prev - 1);
  }

  function nextSlide() {
    setEndTransition(false);
    setActiveImage((prev) => prev + 1);
  }

  function prevSlideMobile() {
    if(activeImageMobile > 0) {
      setActiveImageMobile((prev) => prev - 1);
    }
  }
  
  function nextSlideMobile() {
    if(activeImageMobile < imageArray.length - 1) {
      setActiveImageMobile((prev) => prev + 1);
    }
  }

  return (
    <div className={styles.sitePlan} id="section-4">
      <div className={styles.heading}>
        <img src={bgImage} alt="Site Plan" className={styles.bgImage} />
        <span>Floor Plan</span>
        </div>

        <div className={styles.arrowContainerMobile}>
          {<LeftCircleFilled style={{ opacity: activeImageMobile > 0 ? '1' : '0' }} className={styles.arrow} onClick={() => { activeImageMobile > 0 && prevSlideMobile();}} />}
          {<RightCircleFilled style={{ opacity: activeImageMobile < imageArray.length - 1 ? '1' : '0' }} className={styles.arrow} onClick={() => { activeImageMobile < imageArray.length - 1 && nextSlideMobile();}} />}
        </div>

      <div className={styles.sitePlanContainerWeb}>
        {newImageArray.map((image, index) => (
          <div onClick={() => { setShowModal(true); setShowSelectedImage(index);setArrayType(1); }} className={styles.sitePlanImage + ' ' + (activeImage === index ? styles.center : activeImage === index - 1 ? styles.right1 : activeImage === index + 1 ? styles.left1 : activeImage === index - 2 ? styles.right2 : activeImage === index + 2 ? styles.left2 : "") + ' ' + (endTransition ? styles.endTransition : "")}>
            <img src={image} alt="Site Plan" onMouseEnter={() => setPauseAutoplay(true)} onMouseLeave={() => setPauseAutoplay(false)} />
          </div>
        ))}
      </div>
      <div className={styles.arrowContainerWeb}>
          <LeftCircleFilled className={styles.arrow} onMouseEnter={() => setPauseAutoplay(true)} onMouseLeave={() => setPauseAutoplay(false)} onClick={() => {prevSlide();}} />
          <RightCircleFilled className={styles.arrow} onMouseEnter={() => setPauseAutoplay(true)} onMouseLeave={() => setPauseAutoplay(false)} onClick={() => {nextSlide();}} />
        </div>
      <div className={styles.sitePlanContainerMobile}>
        {imageArrayMobile.map((image, index) => (
          <div onClick={() => { setShowModal(true); setShowSelectedImage(index);setArrayType(2); }} style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.sitePlanImage}>
            <img src={image} alt="Site Plan" onMouseEnter={() => setPauseAutoplay(true)} onMouseLeave={() => setPauseAutoplay(false)} />
          </div>
        ))}
      </div>
      <ImageModal showArrows={true} showPagination={true} imagesArray={arrayType === 1 ? imageArrayMobile : imageArrayMobile} selectedImage={(showSelectedImage%imageArray.length + 1)} showModal={showModal} setShowModal={setShowModal} setSelectedImage={setShowSelectedImage} />
    </div>
  )
}

export default SitePlan